import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "@apollo/client";
import Button from "../Button/Button";
import { UPDATE_EXPIRY_DATE_MUTATION } from "../../graphql/mutations/updateExpiryDate";

const SetExpiry = ({ onClose, selectedData, onApply }) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      expiryDate: "",
    },
  });

  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    setCurrentData(selectedData);
    if (selectedData.expiryDate) {
      const date = new Date(selectedData.expiryDate);
      // Format to local date to preserve the user's timezone
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      setValue("expiryDate", formattedDate);
    }
  }, [selectedData, setValue]);

  const [updateExpiryDate, { loading, error }] = useMutation(
    UPDATE_EXPIRY_DATE_MUTATION
  );

  const handleFormSubmit = async (data) => {
    try {
      const response = await updateExpiryDate({
        variables: {
          id: parseInt(currentData.id, 10),
          expiryDate: data.expiryDate,
        },
      });

      if (response.data.updateClientExpiryDate.client) {
        onApply();
      }
    } catch (err) {
      console.error("Error updating expiry date:", err);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Set Expiry Date</h3>
      </div>
      <div className="basic-modal__body">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="form-group">
            <label htmlFor="expiryDate" className="form-label">
              Expiry Date
            </label>
            <Controller
              name="expiryDate"
              control={control}
              rules={{
                required: "Expiry date is required",
                validate: (value) => {
                  const selectedDate = new Date(value);
                  const currentDate = new Date();
                  currentDate.setHours(0, 0, 0, 0);
                  return (
                    selectedDate >= currentDate || "Date cannot be in the past"
                  );
                },
              }}
              render={({ field }) => (
                <div>
                  <input
                    type="date"
                    id="expiryDate"
                    className="input-group"
                    min={today}
                    {...field}
                  />
                  {errors.expiryDate && (
                    <span className="form-error">
                      {errors.expiryDate.message}
                    </span>
                  )}
                </div>
              )}
            />
          </div>
          {error && <div className="form-error">Error: {error.message}</div>}
          <div className="basic-modal__footer">
            <Button
              type="button"
              onClick={onClose}
              className="button--secondary"
              name="Cancel"
              disabled={loading}
            />
            <Button
              type="submit"
              className="button--primary"
              name={loading ? "Applying..." : "Apply"}
              loading={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SetExpiry;
